module.exports = __webpack_public_path__ + "img/M2-Agency-Logo.45ca40b3.png";